import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-section-heading',
    templateUrl: './section-heading.component.html',
    styleUrl: './section-heading.component.scss',
    standalone: false
})
export class SectionHeadingComponent {
  @Input() id!: string;
  @Input() level: 1 | 2 | 3 | 4 = 1;
  @Input() className = '';

  get tag() {
    return `h${this.level}` as keyof HTMLElementTagNameMap;
  }

  get sizeClasses() {
    switch (this.level) {
      case 1:
        return 'text-4xl font-bold mt-4 mb-4 text-black';
      case 2:
        return 'text-3xl font-semibold mt-6 mb-3 text-black';
      case 3:
        return 'text-xl font-medium mt-5 mb-2 text-black';
      case 4:
        return 'text-lg font-medium mt-4 mb-2 text-black';
      default:
        return '';
    }
  }
}
